import React, { useEffect, useState } from 'react';
import './index.scss';
import {Button, Col, Collapse, Form, List, notification, Rate, Row, Skeleton, Spin, Tabs, Empty} from 'antd';
import { Link, useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthConsumer } from 'shared/contexts/AuthContext';
import API_SERVICE from 'shared/services/api-service';
import benefitCheck from '../../img/benefit-check.png';
import contentPlay from '../../img/content-play-icon.png';
import Parameters from 'shared/parameters';
import TextArea from 'antd/lib/input/TextArea';
import reviewIcon from '../../img/rate-us.jpg';
import moment from 'moment';
import InstructorReview from 'views/InstructorReview/InstructorReview';
let isQuiz:any  = [];
let isContent:any  = [];
const { Panel } = Collapse;
const { TabPane } = Tabs;
export default function MyCoursesDetails() {
    const { t } = useTranslation();
    const history = useHistory();
    const RouteParams: any = useParams();
    const [loading, setLoading] = useState(false);
  const [course, setCourse] = useState(null as any);
  let i = 0;
  const params: any = {
    id: RouteParams['id'],
    type: 'quiz'
};
  const refresh = () => {
    setLoading(true);
    API_SERVICE.fetchCourseById(RouteParams['id']).then((courses) => {
      setCourse(courses.data.data);
    }).catch((e) => {
      notification.error({
        message: API_SERVICE.handleErrors(e),
      });
    }).finally(() => {
      setLoading(false);
    });
  };
  useEffect(() => {
    refresh();
  }, []);
  if (loading || !course || !course.isOrdered) {
    return <Skeleton active={true}/>;
  }
  return (
    <AuthConsumer>
      {({isAuth}) => isAuth && course.isOrdered && <><div className={'mycourse-details-page'}>
        {console.log('coursesssss',course)
        }
        <div className="container-fluid">
		   <div className="row">
		      <div className="col-md-12">
		         <div className="bg-white p-3 br-5px frontend-single-course">
		            <div className="row">
		               <div className="col-md-12 pb-3">
		                  <div className="row m-0">
		                  	<div className="col-lg-8 col-md-7 mt-4 light-shadow">
		                  		<div className="module-tabs mt-2">
		                  			<div className="">
                                        <div className="mt-3 text-right">
		                  					<a href="#" className="text-4f46e5" data-toggle="modal" data-target="#addReview"><u>{t('genDict.Writeareview')}</u></a>
		                  				</div>
		                  				<div className="">
                                            <Tabs defaultActiveKey="1">
                                                <TabPane tab={t('Content')} key="1">
                                                    <div className="mt-4 course-detail-content-collapse contentCollapse">
                                                        <Collapse defaultActiveKey={['1']} onChange={() => {}}>
                                                            {
                                                            course.curriculums && course.curriculums.map((curriculumItem: any,cindex:any) => {
                                                              {isContent = []}
                                                                return <Panel header={
                                                                    <div>
                                                                        
                                                                        <p className="mb-0"><span className="mr-2 text-uppercase text-secondary InterMedium">{t('genDict.Module')} {cindex + 1}</span></p> 
		                                                                <p className="mb-0 InterMedium text-capitalize"><span className="InterMedium">{curriculumItem.title}</span></p>
                                                                    </div>
                                                                    
                                                                } key={curriculumItem.id}>
                                                                    {curriculumItem.contents && curriculumItem.contents.map((curriculumContent: any,contentindex:any) => {
                                                                     
                                                                    return curriculumContent.type !== 'quiz' && <div className="content-table-div">
                                                                       <span className='d-none'> {isContent.push('content')}</span>
                                                                    <table className="table module-table">
                                                                        <tbody>
                                                                        <tr className='bg-transparent'>
                                                                            <td className="pr-md-5">
                                                                                <p className="mb-2 InterMedium d-flex"><span className="mr-2 text-secondary">{i = i + 1}</span> 
                                                                                    {
                                                                                    curriculumContent.type === 'lecture' &&
                                                                                    'Video - '
                                                                                    }
                                                                                    {
                                                                                    curriculumContent.type === 'scorm' &&
                                                                                    'Lession - '
                                                                                    }
                                                                                    {
                                                                                    curriculumContent.type === 'assignment' &&
                                                                                    'Doc - '
                                                                                    }
                                                                                 {curriculumContent.title}</p>
                                                                                <p className="ml-4">{curriculumContent.description}</p>
                                                                            </td>
                                                                            <td className="text-center" style={{width: "200px"}}>
                                                                            <Link
                                                                                to={`/courses/${course.id}/curriculums/${curriculumItem.id}/contents/${curriculumContent.id}`}
                                                                                onClick={(e) => {
                                                                                if (!course.isOrdered && !curriculumContent.is_preview) {
                                                                                    e.preventDefault();
                                                                                    e.stopPropagation();
                                                                                    notification.error({message: t('courses.purchaseCourseFirst')});
                                                                                }
                                                                                }} 
                                                                                className="d-flex align-items-center btn btn-blue text-center text-uppercase" style={{width:"190px"}}>
                                                                                    {curriculumContent.type === 'lecture' && <><img src={contentPlay} className="mr-2" style={{ width: '25px' }} /><span>{t('genDict.Watch')} {curriculumContent.activity === null ? ' Now' : ' Again'}</span></>}
                                                                                    {curriculumContent.type === 'assignment' && <span style={{margin:'auto'}}>{t('genDict.Read')} {curriculumContent.activity === null ? ' Now' : ' Again'}</span>}
                                                                                    {curriculumContent.type === 'scorm' && <span style={{margin:'auto'}}>{t('genDict.view')} {curriculumContent.activity === null ? '' : ' Again'}</span>}
                                                                            </Link>
                                                                            </td>
                                                                        </tr>
                                                                        </tbody>
                                                                    </table>
                                                                    <hr/>
                                                                    </div>
                                                                    })}
                                                                    {isContent.indexOf('content') == -1 ? <Empty /> : ''}
                                                                    <span className='d-none'>{i = 0}</span>
                                                                </Panel>
                                                            })
                                                            }
                                                        </Collapse>
                                                    </div>
                                                </TabPane>
                                                <TabPane tab={t('Quiz')} key="2">
                                                <div className="mt-4 course-detail-content-collapse contentCollapse">
                                                        <Collapse defaultActiveKey={['1']} onChange={() => {}}>
                                                            {
                                                            course.curriculums && course.curriculums.map((curriculumItem: any,cindex:any) => {
                                                              {isQuiz = []}
                                                                return <Panel header={
                                                                    <div>
                                                                        
                                                                        <p className="mb-0"><span className="mr-2 text-uppercase text-secondary InterMedium">{t('genDict.Module')} {cindex + 1}</span></p> 
		                                                                <p className="mb-0 InterMedium text-capitalize"><span className="InterMedium">{curriculumItem.title}</span></p>
                                                                    </div>
                                                                    
                                                                } key={curriculumItem.id}>
                                                                  
                                                                    {curriculumItem.contents && curriculumItem.contents.map((curriculumContent: any,contentindex:any) => {
                                                                      {isQuiz.push(curriculumContent.type)}
                                                                    return curriculumContent.type === 'quiz' && <div className="content-table-div">
                                                                      
                                                                    <table className="table module-table">
                                                                        <tbody>
                                                                        <tr className='bg-transparent'>
                                                                            <td className="pr-md-5">
                                                                                <p className="mb-2 InterMedium d-flex"><span className="mr-2 text-secondary">{i = i + 1}</span> 
                                                                                    {
                                                                                    curriculumContent.type === 'quiz' &&
                                                                                    'Quiz - '
                                                                                    }
                                                                                 {curriculumContent.title}</p>
                                                                                <p className="ml-4">{curriculumContent.description}</p>
                                                                            </td>
                                                                            <td className="text-center" style={{width: "200px"}}>
                                                                            <Link
                                                                                to={`/courses/${course.id}/curriculums/${curriculumItem.id}/contents/${curriculumContent.id}`}
                                                                                onClick={(e) => {
                                                                                if (!course.isOrdered && !curriculumContent.is_preview) {
                                                                                    e.preventDefault();
                                                                                    e.stopPropagation();
                                                                                    notification.error({message: t('courses.purchaseCourseFirst')});
                                                                                }
                                                                                }} 
                                                                                className="d-flex align-items-center btn btn-blue text-uppercase"><span style={{margin:'auto'}}>{curriculumContent.activity === null ? ' Start Now' : ' Retake'}</span></Link>
                                                                            </td>
                                                                        </tr>
                                                                        </tbody>
                                                                    </table>
                                                                    <hr/>
                                                                    </div>
                                                                    })}
                                                                    {isQuiz.indexOf('quiz') == -1 ? <Empty /> : ''}
                                                                    <span className='d-none'>{i = 0}</span>
                                                                </Panel>
                                                            })
                                                            }
                                                        </Collapse>
                                                    </div>
                                                </TabPane>
                                            </Tabs>
		                  				</div>
		                  			</div>
		                           </div>
		                  	</div>
		                  	<div className="col-lg-4 col-md-5 mt-4 pl-4 pr-4 light-shadow">
		                  		<div className="about-course mt-4">
			                  		{/* <h4>About This Course</h4> */}
                            <h4>{t('genDict.AboutThisCourse')}</h4>
			                  		<div className="d-flex mt-3 mb-3 align-items-center">
					                  <div className="mr-3">
					                      <img src={Parameters.ImageBaseUrl + course?.author?.avatar_image?.slug + course?.author?.avatar_image?.ext} className="uploaded-img-cat" height="65" width="65" />
					                  </div>
					                  <div className="">
					                      <h5 className="mb-0 font-18px">
                                  {course?.author?.name}&nbsp;&nbsp;&nbsp;<Rate disabled allowHalf defaultValue={course?.author?.avgRating} />                              
                                </h5>
					                      <p className="mb-0 mt-2 text-secondary">{t('genDict.Instructor')} &nbsp;
                                  <a href="#" className="text-4f46e5" data-toggle="modal" data-target="#addInstructorReview">
                                    <img src={reviewIcon} height={18} width={18} title={'Rate me'}/>
                                  </a>
                                </p>
                                <p>
                                  
                                </p>
					                  </div>
						            </div>
						            <div className="desc">
						            	<p className="mb-0">{course?.author?.about_me}</p>
						            </div>
						        </div>
					            {/* <hr/>
					            <div className="course-completion">
					            	<h4 className="mb-3">{t('genDict.CourseCompletion')}</h4>
					            	<div className="pos-relative">
					            		<span className="float-left">{Math.round(course.completion_percentage)}% {t('genDict.Completed')}</span>
							            <span className="float-right">{t('genDict.Module')} {course.complete_modules}/{course.total_modules}</span>
							            <div className="progress" style={{background:"linear-gradient(to right, #34d399 "+`${course.completion_percentage}`+"%,#efefef 0)"}}></div>
							        </div>
							        <ul className="list-style-none mt-4">
                        {course.curriculums && course.curriculums.map((moduleItem: any,cindex:any) => {
                            
                            return moduleItem.contents && moduleItem.contents.map((moduleContent: any) => {
                                console.log("moduleContent",moduleContent)
                                return <li className="mb-4">
                                    <div className="d-flex">
                                        {moduleContent.is_complete ? 
                                            <img src={benefitCheck} className="mr-3 mt-1 benefit-check" />
                                        :
                                            <span className="text-secondary mr-3">0{cindex + 1}</span>
                                        }
                                        <span role="button" className='text-4f46e5 w-100'
                                        onClick={() => {
                                            history.push("/courses/"+RouteParams['id']+"/curriculums/"+moduleItem.id+"/contents/"+moduleContent.id)
                                        }}
                                        >
                                            {moduleContent?.title}
                                            {moduleContent.type == 'quiz' && moduleContent.activity != null ? <><br /><span className="small text-secondary">
                                        {moduleContent.activity != null ?
                                          Math.round(moduleContent.activity.user_score) + '/' + Math.round(moduleContent.activity.total_score)
                                          : 'Not Yet Completed'}
                                      </span><span className="small text-secondary float-right">
                                          {moduleContent.activity != null ?
                                            moduleContent.activity.user_score === moduleContent.activity.total_score ? "Pass" : "Fail"
                                            :
                                            ''}
                                        </span></>
                                            :<></>}
                                        </span>
                                    </div>
                                </li>
                            })
                        })}
									    </ul>
                                  
					            </div> */}
		                  	</div>
		                  </div>
		               </div>
		            </div>
		         </div>
		      </div>
		   </div>
		</div>
        </div>
        <div className="modal p-0" id="addReview">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body p-4">
                <button id="closeForm" type="button" className="close" data-dismiss="modal" style={{marginTop:'-12px'}}>&times;</button>
                <ReviewsList refresh={refresh} course={course}/>
              </div>
            </div>
          </div>
        </div>
        
        <InstructorReview authorId={course.author.id} />

        </>
      }
    </AuthConsumer>

  );
}
function ReviewsList({course, refresh}: any) {
    const {t}: any = useTranslation();
    const [ratings, setRatings] = useState(null as any);
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [form] = Form.useForm();
    const [fields] = useState([] as any[]);
    useEffect(() => {
      setLoading(true);
      API_SERVICE.fetchCourseReviewsByCourseId(course.id).then(({data: {data}}) => {
        const {items, me} = data;
        const m = me && items.find((i: any) => {
          return i.id === me.id;
        });
        if (!m && me) {
          items.splice(0, 0, me);
        }
        setRatings({reviews: items, me});
      }).catch((e) => {
        notification.error({
          message: API_SERVICE.handleErrors(e),
        });
      }).finally(() => {
        setLoading(false);
      });
    }, []);
    if (loading || ratings === null) {
      return <Spin/>;
    }
    return <div className={'ratings-list-wrapper'}>
      <List
        itemLayout="vertical"
        size="large"
        pagination={{
          hideOnSinglePage: true,
          pageSize: 10,
        }}
  
        dataSource={ratings.reviews}
        renderItem={(item: any, i: number) => (
          <List.Item
            key={i}
          >
            <List.Item.Meta
              title={<Row gutter={20}>
                <Col flex={'auto'}>
                  {item.user.name} <Rate disabled defaultValue={item.rating}/>
                </Col>
                <Col>
                  {moment(new Date(item.created_at)).format('LLL')}
                </Col>
              </Row>}
            />
            {item.review}
          </List.Item>
        )}
      />
      {
        !ratings.me && <Form
          size="large"
          form={form}
          style={{paddingLeft: '20px'}}
          fields={fields}
          onFinish={async (values) => {
            setSubmitting(true);
            API_SERVICE.submitReview({...values, courseId: course.id}).then((d: any) => {
              let FormClose = document.getElementById("closeForm") as HTMLElement
              FormClose.click()
              form.resetFields();
              refresh();
            }).catch((e: any) => {
              notification.error({
                message: API_SERVICE.handleErrors(e),
              });
            }).finally(() => {
              setSubmitting(false);
              let FormClose = document.getElementById("closeForm") as HTMLElement
              FormClose.click()
              form.resetFields();
            });
          }
          }
          layout="vertical"
          requiredMark={false}
        >
          <Form.Item
            label={t('review.label')}
            name="review"
            rules={[
              {required: true, message: t('review.required')},
            ]}
          >
            <TextArea className='br-5' rows={4}/>
          </Form.Item>
          <Form.Item
            label={t('rating.label')}
            name="rating"
            initialValue={1}
            rules={[
              {required: true, message: t('rating.required')},
            ]}
          >
            <Rate allowClear={false}/>
          </Form.Item>
          <Form.Item>
            <Button
              htmlType="submit"
              loading={submitting}
              shape="round"
              size={'large'}
              className="submit btn btn-blue"
            >
              {t('genDict.submit')}
            </Button>
          </Form.Item>
        </Form>
      }
    </div>;
  }